package com.upcominds.expedite.features.signIn

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.data.auth.AuthRepository
import com.upcominds.expedite.data.mobilelogs.logMobileError
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch


data class SignInUiState(
    val loading: Boolean = false,
    val error: String? = null,
)

sealed class SignInEvent {
    object LoginSuccess : SignInEvent()
}

class SignInViewModel(
    private val authRepository: AuthRepository
): ViewModel()  {

    private val _uiState = MutableStateFlow(SignInUiState())
    val uiState: StateFlow<SignInUiState> = _uiState.asStateFlow()

    private val _events = MutableSharedFlow<SignInEvent>()
    val events: SharedFlow<SignInEvent> = _events.asSharedFlow()

    fun signInWithBrowser() {
        if (_uiState.value.loading) return
        viewModelScope.launch {
            _uiState.update { it.copy(loading = true, error = null) }
            try {
                authRepository.login()
                NetworkClient.clearAuthTokenCache()
                _events.emit(SignInEvent.LoginSuccess)
            } catch (e: Exception) {
                logMobileError("SignInViewModel.signInWithBrowser", e)
                _uiState.update {
                    it.copy(
                        loading = false,
                        error = "Login was cancelled or failed. Please try again."
                    )
                }
                return@launch
            }

            _uiState.update { it.copy(loading = false) }
        }
    }

    fun clearError() {
        _uiState.update { it.copy(error = null) }
    }
}
